export enum AddContributorType {
  Registered = 1,
  Unregistered,
  ParentProject,
}
